var exports = {
  "kL": "xa15a2ab7--1062a8--container",
  "O0": "xa15a2ab7--1062a8--rating",
  "zH": "xa15a2ab7--1062a8--details",
  "Wn": "xa15a2ab7--1062a8--pointer",
};

module.exports = exports;
